import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";

const instanceAxiosNewAccount = axios.create({});

instanceAxiosNewAccount.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    logger.log(error);
    toast.error("Ocorreu um erro inesperado."); // toast.error("An unexpected error occurrred.");
  }

  return Promise.reject(error);
});

export default {
  get: instanceAxiosNewAccount.get,
};
